"use client";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

export default function GovernanceError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <div className="flex flex-col items-start gap-[var(--space-md)] p-[var(--space-lg)]">
      <Alert>
        <AlertTitle>Couldn’t load Governance</AlertTitle>
        <AlertDescription>Try again, or choose another workspace while Governance is unavailable.</AlertDescription>
      </Alert>
      <Button variant="outline" onClick={reset}>Try again</Button>
    </div>
  );
}
